import "./GameShared.css";

export default function GameResults({
  title = "Resultados",
  results = [],
  onRepeat,
  onChangeDifficulty,
}) {
  return (
    <section className="game-results">
      <h2>{title}</h2>

      <div className="game-results-grid">
        {results.map((item) => (
          <div key={item.label}>
            <strong>{item.value}</strong>
            <span>{item.label}</span>
          </div>
        ))}
      </div>

      <div className="game-results-actions">
        {onRepeat && (
          <button type="button" onClick={onRepeat}>
            Repetir juego
          </button>
        )}

        {onChangeDifficulty && (
          <button type="button" onClick={onChangeDifficulty}>
            Cambiar dificultad
          </button>
        )}
      </div>
    </section>
  );
}